/* Shared formula marquee: one implementation for every rendering of the visual. */
(function () {
  'use strict';
  if (window.__fizzyFormulaMarquee) return;
  window.__fizzyFormulaMarquee = true;

  var instances = new Map();
  function initFormula(group) {
    if (instances.has(group)) return;
    var toggle = group.querySelector('[data-sv-formula-toggle]');
    var rows = Array.from(group.querySelectorAll('.sv-formula__row')).map(function (row, index) {
      var track = row.querySelector('.sv-formula__track');
      var source = track && track.querySelector('.sv-formula__set');
      return {
        row: row,
        track: track,
        source: source,
        clones: [],
        speed: [24, 34, 19][index % 3],
        distance: null,
        originalDistance: track && track.style.getPropertyValue('--sv-formula-distance'),
        originalDuration: track && track.style.getPropertyValue('--sv-formula-duration')
      };
    });
    if (!toggle || !rows.length || rows.some(function (row) { return !row.track || !row.source; }) ||
      !('IntersectionObserver' in window) || !('ResizeObserver' in window)) return;

    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused = false;
    var visible = false;
    var prepared = false;
    var disposed = false;
    var originalToggle = {
      disabled: toggle.disabled,
      pressed: toggle.getAttribute('aria-pressed'),
      label: toggle.getAttribute('aria-label'),
      title: toggle.getAttribute('title')
    };

    function syncFormula() {
      var enabled = prepared && !preference.matches;
      var label = preference.matches ? 'Formula animation is off for reduced motion' :
        !prepared ? 'Formula animation is unavailable' : paused ? 'Play formula animation' : 'Pause formula animation';
      toggle.disabled = !enabled;
      toggle.setAttribute('aria-pressed', String(paused || !enabled));
      toggle.setAttribute('aria-label', label);
      toggle.setAttribute('title', label);
      group.setAttribute('data-sv-formula-running', String(enabled && !paused && visible && !document.hidden));
    }

    function measureFormula() {
      if (disposed) return;
      if (preference.matches) return;
      // Switch the source sets to their nowrap measurement layout before reading widths.
      if (!group.hasAttribute('data-sv-formula-ready')) group.setAttribute('data-sv-formula-ready', '');
      // Each source set includes its trailing gap. Read every row before changing any track.
      var sizes = rows.map(function (row) {
        return { viewport: row.row.getBoundingClientRect().width, source: row.source.getBoundingClientRect().width };
      });
      var wasPrepared = prepared;
      prepared = sizes.every(function (size) { return size.viewport > 0 && size.source > 0; });
      rows.forEach(function (row, index) {
        var size = sizes[index];
        if (size.viewport <= 0 || size.source <= 0) return;
        var copies = Math.ceil(size.viewport / size.source);
        while (row.clones.length > copies) row.clones.pop().remove();
        while (row.clones.length < copies) {
          var clone = row.source.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.setAttribute('data-sv-formula-clone', '');
          clone.removeAttribute('id');
          clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
          row.track.appendChild(clone);
          row.clones.push(clone);
        }
        if (row.distance !== size.source) {
          row.distance = size.source;
          row.track.style.setProperty('--sv-formula-distance', size.source + 'px');
          row.track.style.setProperty('--sv-formula-duration', (size.source / row.speed) + 's');
        }
      });
      if (!prepared) group.removeAttribute('data-sv-formula-ready');
      if (prepared !== wasPrepared) syncFormula();
    }

    function onFormulaToggle() {
      if (toggle.disabled) return;
      paused = !paused;
      syncFormula();
    }
    function onFormulaPreference() {
      measureFormula();
      syncFormula();
    }

    var visibilityObserver = new IntersectionObserver(function (entries) {
      if (disposed) return;
      entries.forEach(function (entry) { if (entry.target === group) visible = entry.isIntersecting; });
      syncFormula();
    }, { threshold: 0 });
    var resizeObserver = new ResizeObserver(measureFormula);
    visibilityObserver.observe(group);
    rows.forEach(function (row) {
      resizeObserver.observe(row.row);
      resizeObserver.observe(row.source);
    });
    toggle.addEventListener('click', onFormulaToggle);
    document.addEventListener('visibilitychange', syncFormula);
    if (preference.addEventListener) preference.addEventListener('change', onFormulaPreference);
    else preference.addListener(onFormulaPreference);
    measureFormula();
    syncFormula();

    instances.set(group, function () {
      disposed = true;
      visibilityObserver.disconnect();
      resizeObserver.disconnect();
      toggle.removeEventListener('click', onFormulaToggle);
      document.removeEventListener('visibilitychange', syncFormula);
      if (preference.removeEventListener) preference.removeEventListener('change', onFormulaPreference);
      else preference.removeListener(onFormulaPreference);
      rows.forEach(function (row) {
        row.clones.forEach(function (clone) { clone.remove(); });
        if (row.originalDistance) row.track.style.setProperty('--sv-formula-distance', row.originalDistance);
        else row.track.style.removeProperty('--sv-formula-distance');
        if (row.originalDuration) row.track.style.setProperty('--sv-formula-duration', row.originalDuration);
        else row.track.style.removeProperty('--sv-formula-duration');
      });
      toggle.disabled = originalToggle.disabled;
      [['aria-pressed', originalToggle.pressed], ['aria-label', originalToggle.label], ['title', originalToggle.title]].forEach(function (attribute) {
        if (attribute[1] === null) toggle.removeAttribute(attribute[0]);
        else toggle.setAttribute(attribute[0], attribute[1]);
      });
      group.removeAttribute('data-sv-formula-ready');
      group.removeAttribute('data-sv-formula-running');
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-sv-formula-motion]')) initFormula(scope);
    scope.querySelectorAll('[data-sv-formula-motion]').forEach(initFormula);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, group) {
      if (event.target === group || event.target.contains(group)) {
        dispose();
        instances.delete(group);
      }
    });
  });
})();
